var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sui-button-container", class: [_vm.fixedClass] },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "touch-class",
              rawName: "v-touch-class",
              value: "sui-button--active",
              expression: "'sui-button--active'"
            }
          ],
          staticClass: "sui-button",
          class: [
            _vm.typeClass,
            _vm.invalidClass,
            _vm.sizeClass,
            _vm.disabledClass,
            _vm.radiusClass
          ],
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.onClick }
        },
        [
          _vm.loading
            ? _c("img", {
                staticClass: "sui-animation-rotate",
                attrs: {
                  src:
                    "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0OCA0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0yNCA0NmMtMS4xIDAtMS45LS45LTEuOS0xLjlzLjktMS45IDEuOS0xLjljMTAgMCAxOC4yLTguMSAxOC4yLTE4LjJzLTguMi0xOC4yLTE4LjItMTguMi0xOC4yIDguMi0xOC4yIDE4LjJjMCAxLjEtLjkgMS45LTEuOSAxLjlzLTEuOS0uOC0xLjktMS45YzAtMTIuMiA5LjgtMjIgMjItMjJzMjIgOS44IDIyIDIyLTkuOCAyMi0yMiAyMnoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=",
                  width: "20"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.title && _vm.$slots.support
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "sui-button-title" },
                  [_vm._t("title")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sui-button-support" },
                  [_vm._t("support")],
                  2
                )
              ])
            : _vm._t("default")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }